import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';


import './index.css';
import App from './App';

// Redirect Firebase Hosting domains to custom domain
const firebaseDomains = [
  'nextgo.web.app',
  'nextgo.firebaseapp.com',
];

if (firebaseDomains.includes(window.location.hostname)) {
  window.location.replace(
    'https://nextgo.myloyaltea.com' +
    window.location.pathname +
    window.location.search +
    window.location.hash
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </BrowserRouter>
  </React.StrictMode>
);